<template>
    <div>
        <div class="cart-item" v-for="(item, key) in products" :key="key">
            <div class="row align-items-center">
                <div class="col-12 col-md-8">
                    <span v-if="item.type == 'toll'" class="category">{{ capitalize($tc('tollWord', 0)) }},
                        {{ $tc('my_orders_passings', item.quantity) }}</span>
                    <span v-if="item.type == 'vignette'" class="category">{{ capitalize($tc('vignetteWord', 1)) }},
                        {{ $tc(item.days == 12 ? 'months' : 'days', item.days) }}</span>
                </div>
                <div class="col-12 col-md-4 text-md-right">
                    <p class="f-style m-md-0">{{ item.price }} {{ $tc('currency', item.price) }}</p>
                </div>
            </div>
            <template v-if="item.type == 'vignette'">
                <div class="row mt-md-2">
                    <div class="col-md-6">
                        <span class="ancillary">{{ capitalize($t('cart_available_from')) }}</span>
                    </div>
                    <div class="col-md-6 text-md-right">
                        <p class="f-style">{{ formatDate(item.fromDate) }}</p>
                    </div>
                </div>
            </template>
            <template v-if="item.chasisNo">
                <div class="row">
                    <div class="col-md-6">
                        <span class="ancillary">{{ $t('label_chasis_number') }}</span>
                    </div>
                    <div class="col-md-6 text-md-right">
                        <p class="f-style">{{ item.chasisNo }}</p>
                    </div>
                </div>
            </template>
            <div class="row">
                <div class="col-md-6">
                    <span class="ancillary">{{ $t('label_license_plate') }}</span>
                </div>
                <div class="col-md-6 text-md-right">
                    <p class="f-style">{{ item.plateNo }}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <span class="ancillary">{{ item.category_name }}</span>
                </div>
                <div class="col-md-6 text-md-right">
                    <p class="f-style" v-html="item.category_description"></p>
                </div>
            </div>
            <div class="row" v-if="item.type == 'toll'">
                <div class="col-md-6">
                    <span class="ancillary">{{ capitalize($tc('passing', item.quantity)) }}</span>
                </div>
                <div class="col-md-6 text-md-right">
                    <p class="f-style" v-html="item.quantity"></p>
                </div>
            </div>
            <span class="ancillary d-block" v-if="item.sms_confirm_notification && getSmsSetting != null"><span class="far fa-envelope"></span>
                {{ $tc('sms_notification_confirmation', Math.ceil(getSmsSetting.value), { 'price': getSmsSettingMessage() }) }}</span>
            <span class="ancillary d-block" v-if="item.sms_expiry_notification && getSmsSetting != null"><span class="far fa-envelope"></span> {{
                $tc('sms_notification_expiry', Math.ceil(getSmsSetting.value), { 'price': getSmsSettingMessage() })
            }}</span>
            <span class="ancillary d-block" v-if="item.cnair_expiry_notification"><span class="far fa-envelope"></span> {{
                $t('cnair_notification_expiry')
            }}</span>
            <div class="d-flex justify-content-end mt-4" v-if="showDeleteBtn">
                <div v-on:click="editItem(key)" class="mr-md-5 mr-3" v-if="!item.transaction_errors">
                    <div class="icon-wrapper">
                        <div class="icon edit-icon"></div>
                    </div>
                </div>
                <div v-on:click="removeItem(key)">
                    <div class="icon-wrapper">
                        <div class="icon delete-icon"></div>
                    </div>
                </div>
            </div>
            <template v-if="item.transaction_errors">
                <span class="f-style text-danger text-break" :key="key"
                    v-for="(err, key) in item.transaction_errors"><b>{{ err }}</b></span>
            </template>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'CartProducts',
    props: {
        products: {
            type: Array,
            default: null
        },
        showDeleteBtn: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters({
            getEditProduct: 'cart/getEditProduct'
        }),

        ...mapGetters('settings', [
            'getSmsSetting',
            'getSmsSettingMessage'
        ]),

    },
    methods: {

        ...mapActions('cart', [
            'removeItemFromCart',
            'editProduct'
        ]),

        removeItem(index) {
            this.$dialog.confirm({
                title: this.$t('delete_product_title'),
                message: this.$t('delete_product'),
                cancelButtonText: this.$t('no'),
                confirmButtonText: this.$t('yes'),
            })
                .then(() => {
                    this.removeItemFromCart(index);
                })
                .catch(() => {
                });
        },

        editItem(index) {
            this.editProduct(index);

            if (this.getEditProduct.type == 'vignette') {
                //redirect to vignette add
                this.$router.push({ name: 'vignette-category', params: { id: this.getEditProduct.category } });
            }
            else {
                //redirect to toll add
                this.$router.push({ name: 'toll-category', params: { id: this.getEditProduct.category } });
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/scss/_variables';

$lightgrey: lightgrey;

.cart-item {
    border: none;
    border-radius: 4px;
    background-color: #EEEDEC;
    padding: 20px 25px;
    font-size: 14px;
    margin: 23px 0 30px;
    // min-height: 230px;

    label {
        font-size: 16px;
        cursor: pointer;
    }

    @media only screen and (min-width: 766px) {
        min-width: 600px;
    }

    @media only screen and (max-width: 765px) {
        width: 100%;

        .icon-wrapper {
            background: white;
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
        }
    }

    p {
        margin-bottom: 10px;
    }


    .category {

        font-weight: bold;
        font-size: 22px;
    }

    .delete-icon {
        color: $black;
        cursor: pointer;
    }

    .edit-icon {
        color: $black;
        cursor: pointer;
    }

    .f-style {

        font-weight: bold;
    }
}
</style>
